import React, { useEffect } from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import { useOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import { loginSso } from '../../../actions/account.actions';
import LogoWhite from '../../../assets/images/LogoWhite';
import { notifyError } from '../../../layouts/Notify/actions';
import { accountRoutesConst } from '../../../routes/account.routes';

const useStyles = makeStyles((theme: Theme) => ({
  logoWrapper: {
    width: '100%',
  },
  logo: {
    [theme.breakpoints.down('xs')]: {
      transform: 'scale(0.75)',
      transformOrigin: 'left top',
    },
  },
}));
type Props = MappedState & MappedDispatch;
const OktaLoginWrapper: React.FC<Props> = ({
  ssoLoginError,
  dispatchNotifyError,
  dispachLoginSso,
}: Props) => {
  const classes = useStyles();
  const { authState } = useOktaAuth();
  const history = useHistory();

  //@ts-ignore - TS issue with okta and custom objects
  const email = authState?.users?.email;
  const accessToken = authState?.accessToken?.accessToken;

  const onError = () => {
    history.push(accountRoutesConst.Login);
    dispatchNotifyError();
  };

  useEffect(() => {
    email && accessToken ? dispachLoginSso(email, accessToken) : onError();
  }, []);

  useEffect(() => {
    ssoLoginError && onError();
  }, [ssoLoginError]);

  return (
    <div className={classes.logoWrapper}>
      <LogoWhite className={classes.logo} />
    </div>
  );
};

type MappedState = ReturnType<ReturnType<typeof mapStateToProps>>;
const mapStateToProps = () => {
  return (state: AppState) => {
    const { account } = state;
    return {
      ssoLoginError: account.ssoLoginError,
    };
  };
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  dispachLoginSso: (email: string, accessToken: string) => dispatch(loginSso(email, accessToken)),
  dispatchNotifyError: () =>
    dispatch(notifyError({ message: 'Something_went_wrong', translate: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OktaLoginWrapper);
